function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import o, { createContext as H, useContext as E, useEffect as m, useState as u } from "react";
import { createPortal as g } from "react-dom";
import { useDisposables as h } from '../hooks/use-disposables.js';
import { objectToFormEntries as x } from '../utils/form.js';
import { compact as y } from '../utils/render.js';
import { Hidden as l, HiddenFeatures as d } from './hidden.js';
var f = /*#__PURE__*/H(null);
function W(t) {
  var _u = u(null),
    _u2 = _slicedToArray(_u, 2),
    e = _u2[0],
    r = _u2[1];
  return /*#__PURE__*/o.createElement(f.Provider, {
    value: {
      target: e
    }
  }, t.children, /*#__PURE__*/o.createElement(l, {
    features: d.Hidden,
    ref: r
  }));
}
function c(_ref) {
  var t = _ref.children;
  var e = E(f);
  if (!e) return /*#__PURE__*/o.createElement(o.Fragment, null, t);
  var r = e.target;
  return r ? /*#__PURE__*/g( /*#__PURE__*/o.createElement(o.Fragment, null, t), r) : null;
}
function j(_ref2) {
  var t = _ref2.data,
    e = _ref2.form,
    r = _ref2.disabled,
    n = _ref2.onReset,
    F = _ref2.overrides;
  var _u3 = u(null),
    _u4 = _slicedToArray(_u3, 2),
    i = _u4[0],
    a = _u4[1],
    p = h();
  return m(function () {
    if (n && i) return p.addEventListener(i, "reset", n);
  }, [i, e, n]), /*#__PURE__*/o.createElement(c, null, /*#__PURE__*/o.createElement(C, {
    setForm: a,
    formId: e
  }), x(t).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      s = _ref4[0],
      v = _ref4[1];
    return /*#__PURE__*/o.createElement(l, _objectSpread({
      features: d.Hidden
    }, y(_objectSpread({
      key: s,
      as: "input",
      type: "hidden",
      hidden: !0,
      readOnly: !0,
      form: e,
      disabled: r,
      name: s,
      value: v
    }, F))));
  }));
}
function C(_ref5) {
  var t = _ref5.setForm,
    e = _ref5.formId;
  return m(function () {
    if (e) {
      var r = document.getElementById(e);
      r && t(r);
    }
  }, [t, e]), e ? null : /*#__PURE__*/o.createElement(l, {
    features: d.Hidden,
    as: "input",
    type: "hidden",
    hidden: !0,
    readOnly: !0,
    ref: function ref(r) {
      if (!r) return;
      var n = r.closest("form");
      n && t(n);
    }
  });
}
export { j as FormFields, W as FormFieldsProvider, c as HoistFormFields };